/* eslint-disable array-callback-return */
import { CircularProgress, Flex, FormControl, Grid, Progress, Text, useToast } from '@chakra-ui/react'
import { useEffect, useState } from 'react'
import { FaPencilAlt } from 'react-icons/fa'
import { MdClose } from 'react-icons/md'
import Modal from 'react-modal'
import { ButtonCmp } from '../../../../../components/ButtonCmp'
import { CheckboxCmp } from '../../../../../components/CheckboxCmp'
import { ElementoTooltipCmp } from '../../../../../components/ElementoTooltipCmp'
import LoadingContainer from '../../../../../components/LoadingContainer'
import { DescricaoCargo, NivelColaborador } from '../../../../../interfaces'
import { appApi } from '../../../../../services/appApi'
import { ModalTextoApoio } from '../ModalTextoApoio'
import { WhiteModal } from './styles'

interface iModalProps {
  isOpen: boolean
  onClose: () => void
}

export interface iTextoAjuda {
  cargoId: string
  texto: string
}

export const ModalIA: React.FC<iModalProps> = ({ isOpen, onClose }) => {
  const toast = useToast()
  const [IsLoading, setIsLoading] = useState(false)
  const [IsProcessando, setIsProcessando] = useState(false)
  const [CargosSelecionadosId, setCargosSelecionadosId] = useState<string[]>([])
  const [Erros, setErros] = useState<Array<{ id: string, val: string }>>([])
  const [Concluidos, setConcluidos] = useState(0)

  function GetDescritivos(): void {
    setIsLoading(true)

    appApi.get('api/CargosESalarios')
      .then((res) => {
        setCargos(res.data)
      })
      .catch(err => console.log(err))
      .finally(() => setIsLoading(false))
  }

  async function onCreate(): Promise<void> {
    setConcluidos(0)
    setErros([])
    setIsProcessando(true)

    for (const c of Cargos) {
      if (CargosSelecionadosId.includes(c.id)) {
        try {
          const textoApoio = TextoAjuda.find(t => t.cargoId === c.id)
          await appApi.post(`api/CargosESalarios/${c.id}/GerarDados?textoApoio=${textoApoio?.texto ?? ''}`, c)
          setConcluidos(prev => prev + 1)
        } catch (err) {
          console.log(err)
          setErros(prev => [...prev, { id: c.id, val: 'Erro ao gerar dados do cargo: ' + c.nomeCargo }])
          setConcluidos(prev => prev + 1)
        }
      }
    }

    setIsProcessando(false)
    if (Erros.length === 0) {
      onClose()
      toast({
        title: 'Informações geradas com sucesso',
        status: 'success',
        position: 'top',
        duration: 4000
      })
      setCargosSelecionadosId([])
    } else {
      toast({
        title: `Informações geradas com sucesso, porém com ${Erros.length} erros retornados`,
        status: 'success',
        position: 'top',
        duration: 4000
      })
    }
  }

  const [Cargos, setCargos] = useState<DescricaoCargo[]>([])
  const [TextoAjuda, setTextoAjuda] = useState<iTextoAjuda[]>([])
  const [EditTextoApoio, setEditTextoApoio] = useState<iTextoAjuda>()

  function verificarListas(nivel: NivelColaborador): boolean {
    const conhecimentos = nivel.conhecimentosTecnicos.filter(e => e !== '')
    const habilidades = nivel.habilidades.filter(e => e !== '')
    const atribuicoes = nivel.atribuicoes.filter(e => e !== '')
    const competencias = nivel.competenciasComportamentais.filter(e => e !== '')

    if (
      conhecimentos.length === 0 &&
      habilidades.length === 0 &&
      atribuicoes.length === 0 &&
      competencias.length === 0
    ) {
      return true
    }

    return false
  }

  function onSaveTextoApoio(obj: iTextoAjuda): void {
    const copy = [...TextoAjuda]
    const index = copy.findIndex(e => e.cargoId === obj.cargoId)
    if (index !== -1) {
      copy[index].texto = obj.texto
    } else {
      copy.push(obj)
    }

    setTextoAjuda(copy)
  }

  useEffect(() => {
    if (Cargos?.length === 0) {
      GetDescritivos()
    }
  }, [])

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      overlayClassName="react-modal-overlay"
      className="react-modal-content-default"
    >
      {EditTextoApoio && <ModalTextoApoio
        isOpen
        obj={EditTextoApoio}
        onClose={() => setEditTextoApoio(undefined)}
        onCreate={onSaveTextoApoio}
      />}
      <WhiteModal>
        {(IsProcessando || Erros.length > 0) && <Flex alignItems={'center'} flexDir='column' justifyContent={'center'} gap={'1rem'}>
            <Flex alignItems={'center'} gap={'.75rem'}>
              <Text fontWeight={'bold'}>Cargos processados {Concluidos}/{CargosSelecionadosId.length}</Text>
              <CircularProgress isIndeterminate color="green" size={'20px'}></CircularProgress>
            </Flex>
            <Progress hasStripe isAnimated w={'100%'} color="green" value={(Concluidos / CargosSelecionadosId.length) * 100}/>
            {Erros.length > 0 && <Flex flexDir={'column'} gap={'.325rem'}>
              <Text fontSize={'14px'} color={'var(--Red)'}>Erros ao gerar as informações dos cargos selecionados: {Erros.length}</Text>
              {Erros.map(e => {
                return <Text fontSize={'14px'} color={'var(--Red)'}>
                  {e.val}
                </Text>
              })}
            </Flex>}
            {!IsProcessando && <Flex gap={'1rem'} justifyContent='center'>
              <ButtonCmp VarColor='c6' onClick={() => {
                setErros([])
                onClose()
              }}>Sair</ButtonCmp>
              <ButtonCmp VarColor='Rosa' onClick={() => {
                setErros([])
              }}>Voltar para lista de cargos</ButtonCmp>
              <ButtonCmp VarColor='Green2' onClick={() => {
                const copy = [...Erros.map((val) => val.id)]
                setCargosSelecionadosId(copy)
                setErros([])
              }}>Voltar para lista de cargos e selecionar os itens com erro</ButtonCmp>
            </Flex>}
          </Flex>}
        {!(IsProcessando || Erros.length > 0) && <LoadingContainer loading={IsLoading} linhas={8}>
          <FormControl as={Flex} flexDir="column" gap="1rem">
            <Flex justifyContent={'space-between'}>
              <h3 style={{ fontSize: '20px', fontWeight: 'bold', color: 'var(--Azul)' }}>
                Gerar informações sobre o cargo com IA
              </h3>
              <Flex color='var(--Red)' _hover={{ color: 'var(--Red-hover)' }}>
                <MdClose cursor={'pointer'} size={18} onClick={onClose}/>
              </Flex>
            </Flex>

            <Flex gap={'.75rem'}>
              <ButtonCmp onClick={() => {
                setCargosSelecionadosId([])
              }} OutlineColor='Red'>Desfazer seleção</ButtonCmp>
              <ButtonCmp onClick={() => {
                setCargosSelecionadosId([...Cargos.map(c => c.id)])
              }} VarColor='Green2'>Selecionar todos</ButtonCmp>
              <ButtonCmp onClick={() => {
                const cargos = [...Cargos.map(c => {
                  if (Object.entries(c.niveis).some(([_, nivel]) => verificarListas(nivel))) {
                    return c.id
                  }
                })]
                setCargosSelecionadosId([...cargos.filter(e => e !== undefined)] as string[])
              }} VarColor='Green2'>Selecionar cargos com informações pendentes</ButtonCmp>
            </Flex>

            <Flex flexDir={'column'} gap=".125rem">
              {Cargos.map((cargo, index) => {
                return <Grid
                  gridTemplateColumns="2fr 2fr 2fr 2fr 1fr"
                  alignItems="center"
                  gap="2rem"
                  px="1rem"
                  py=".75rem"
                  fontSize={'14px'}
                  border={'1px solid var(--c2)'}
                  bg={(index % 2 === 0) ? 'var(--c2)' : 'white'}
                >
                  <Flex direction="row">
                    <CheckboxCmp isChecked={CargosSelecionadosId.some(cid => cid === cargo.id)} OnChange={(val) => {
                      if (val) {
                        setCargosSelecionadosId([...CargosSelecionadosId, cargo.id])
                      } else {
                        setCargosSelecionadosId(CargosSelecionadosId.filter(cid => cid !== cargo.id))
                      }
                    }}>
                      <Text fontWeight={'600'}>{cargo.nomeCargo}</Text>
                    </CheckboxCmp>
                  </Flex>
                  <Flex direction="column">
                    <Text fontWeight={'600'}>{cargo.tipoNivel}</Text>
                  </Flex>
                  <Flex direction="column">
                    <Text color={TextoAjuda.some(t => t.cargoId === cargo.id) ? 'var(--Green3)' : 'var(--Red)'} fontWeight={'600'}>{TextoAjuda.some(t => t.cargoId === cargo.id) ? 'Texto de apoio adicionado' : 'Texto de apoio não foi adicionado'}</Text>
                  </Flex>
                  <Flex direction="column">
                    <Text color={(Object.entries(cargo.niveis).some(([key, nivel]) => verificarListas(nivel))) ? 'var(--Red)' : 'var(--Green3)'} fontWeight={'600'}>{(Object.entries(cargo.niveis).some(([key, nivel]) => verificarListas(nivel))) ? 'Preenchimento pendente' : 'Cargo já preenchido'}</Text>
                  </Flex>
                  <Flex>
                    <ElementoTooltipCmp label='Adicionar ou editar texto de apoio para esse cargo'>
                      <ButtonCmp VarColor='Green2' onClick={() => setEditTextoApoio(TextoAjuda.find(e => e.cargoId === cargo.id) ?? { cargoId: cargo.id, texto: '' })}><FaPencilAlt/></ButtonCmp>
                    </ElementoTooltipCmp>
                  </Flex>
                </Grid>
              })}
            </Flex>
          </FormControl>

          <Flex justifyContent="end" gap=".75rem" mt="1rem">
            <ButtonCmp VarColor="c6" onClick={onClose}>Cancelar</ButtonCmp>
            <ButtonCmp VarColor="Green2" onClick={async () => await onCreate()}>Confirmar</ButtonCmp>
          </Flex>
        </LoadingContainer>}
      </WhiteModal>
    </Modal>
  )
}
